/* jshint node:true */

/**
 * Single point to return API host for data requests to enable
 * @return {Object}     Utility functions to get and modify API host
**/

var liveAPIHost     = 'http://site.api.espn.com',
    qaAPIHost       = 'http://site.api.qa.espn.com',
    iaasAPIHost     = 'http://10.42.47.50:9003';
    //iaasAPIHost2    = 'http://10.42.47.50:9003',

/**
 * Gets a particular key / variable
 * from a given path in an Object
 * @param  {Object} scope
 * @return
**/
function get(payload) {

    if(typeof payload === 'undefined'){
        payload = {};
    }
    if(typeof payload.query === 'undefined'){
        payload.query = {};
    }

    var oQuery  = payload.query,
        sHost   = liveAPIHost;

    if(oQuery.qa || oQuery.useqa){
        sHost = qaAPIHost;
    }else if (oQuery.iaas) {
        sHost = iaasAPIHost;
    }

    return sHost;
}

module.exports = {
    get: get
};



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/helpers/utils/apiHost.js
 **/